export const setService = (markers) => {
  const countOrdersByDate = (data) => {
    const result = {};

    data.forEach((item) => {
      if (item.last_to) {
        const date = item.last_to;
        if (result[date]) {
          result[date].count += 1;
          result[date].ids.push(item.id);
        } else {
          result[date] = {
            date,
            count: 1,
            count1: 0,
            ids: [item.id],
          };
        }
      }
    });

    return Object.values(result);
  };

  const orders = countOrdersByDate(markers);
  const sortedData = orders.sort((a, b) => {
    const dateA = new Date(a.date.split(".").reverse().join("-"));
    const dateB = new Date(b.date.split(".").reverse().join("-"));
    return dateA - dateB;
  });
  
  return sortedData;
};
